import type Owner from '@ember/owner';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsClientsPerformanceComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'Account performance overview';
		this.descText =
			'With the performance overview, you can quickly scan key metrics and goals across clients, brands, locations, franchises, and business units. To get started, create an account first.';

		this.videoUrl = 'https://player.vimeo.com/video/890289759';
		this.videoLength = '2:15';

		this.topImageLightUrl = '/images/placeholders/client-kpis.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/client-kpis.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-client-kpis.png';
		this.imageHeight = 555;

		this.trackingOrigin = 'clients_performance';
	}

	override get createButtonText() {
		return 'Add account';
	}
}
